export const packageList = [
  {
    name: 'sys',
    activeRule: ['ams', 'mcs', 'uamp', 'urm', 'inform-center', 'opa'],
  },
  {
    name: 'bss_common',
    activeRule: []
  },
  {
    name: 'bss',
    activeRule: ['bss'], // 组件平台
  },
  {
    name: 'devops_flow',
    activeRule: []
  }
]
export const remoteModuleConfig = {
  dev: ['sys', 'bss_common', 'bss', 'devops_flow'],
  stg: ['sys', 'bss_common', 'bss', 'devops_flow'],
  uat: ['sys', 'bss_common', 'bss', 'devops_flow'],
  prd: ['sys', 'bss_common', 'bss', 'devops_flow'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/sys/index.js